import { AloftPrice } from '@aloft/toolkit-shared';

import { Typography } from '../../../summary/components/Typography.tsx';
import { hasAdjustments } from '../AdjustmentBreakdown/hasAdjustments.ts';
import { SummarySection } from '../SummarySection.tsx';
import { SummaryTableHorizontal } from '../SummaryTableHorizontal.tsx';
import { TitleAndExportToggleLockup } from '../TitleAndExportToggleLockup.tsx';
import { BreakdownColumn, Tkv2PairedCostSummaryInterfaceV2 } from '../types.ts';
import { adjustment } from '../utils/formatters/adjustment.ts';
import { wholeDollar } from '../utils/formatters/wholeDollar.ts';
import { getTableData } from '../utils/getTableData.ts';

const tableDef: BreakdownColumn[] = [
  {
    header: 'Functional Obsolescence',
    type: 'feature',
    adjustmentType: 'functionalUtility',
    path: 'amount',
    valueFormatter: wholeDollar,
  },
  {
    header: '= Adjustment',
    type: 'adjustment',
    adjustmentType: 'functionalUtility',
    path: 'adjustment',
    valueFormatter: adjustment,
  },
];

export const AdjustmentBreakdownDepreciatedCostMainDwellingFunctionalUtility = (
  props: Tkv2PairedCostSummaryInterfaceV2,
) => {
  const tableData = getTableData(tableDef, props, props.compSequence);

  if (!hasAdjustments(props.results, 'functionalUtility')) {
    return null;
  }

  const sortedPrices = Object.values(tableData)
    .map((row) => row[0])
    .filter(AloftPrice.isAloftPrice)
    .sort((a, b) => (a as AloftPrice).compare(b as AloftPrice));

  const minString = sortedPrices[0]?.toString(true);
  const maxString = sortedPrices[sortedPrices.length - 1]?.toString(true);
  const rangeString = [minString, maxString].join(' to ');

  return (
    <SummarySection marginBottom="2rem">
      <TitleAndExportToggleLockup
        {...props}
        title="Functional Utility"
        id="isDepreciatedCostMainDwellingFunctionalUtilityInExport"
        variant="h3"
      />
      <Typography variant="body1">
        {`A functional utility adjustment is based on the difference in functional obsolescence between the subject and each comparable. These differences ranged from ${rangeString}.`}
      </Typography>
      <SummaryTableHorizontal
        {...props}
        summary={props}
        compSequence={props.compSequence}
        columns={tableDef}
        tableData={tableData}
        subjectHeader="SUB"
        compHeaderPrefix="CP"
      />
    </SummarySection>
  );
};
